import { faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

const ModalBg = styled.div`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalBox = styled.div`
  z-index: 15;
  position: absolute;
  top: calc(50vh - 400px);
  left: calc(50vw - 200px);
  background-color: white;
  align-items: center;
  border-radius: 10px;
  width: 528px;
  height: 747px;
  overflow: scroll;
`;

const TitleBox = styled.div`
  padding: 30px 40px;
  font-weight: 600;
  border-bottom: 1px solid #ededed;
  display: flex;
  justify-content: space-between;
`;

const ContentBox = styled.div`
  padding: 30px 40px;
  font-weight: 500;
  font-size: 12px;
  color: #797979;
  overflow: scroll;
`;

export default function TermsAgreedModal(props: any) {
  return (
    <ModalBg>
      <ModalBox>
        <TitleBox>
          위더스 메이커 개인정보 수집 및 이용 동의
          <FontAwesomeIcon
            icon={faX}
            onClick={() => props.close()}
            style={{ cursor: "pointer" }}
          />
        </TitleBox>
        <ContentBox>
          위더스 메이커 페이지 서비스의 이용과 관련하여 필요한 사항을
          규정합니다.
          <br />
          <br />
          제 1 조 (목적)
          <br />
          <br />
          본 동의서는 [플리더스 테스트 연구소] (이하 "회사")가 제공하는 SaaS 기반
          게임 테스트 플랫폼 서비스 이용과 관련하여, 이용자의 개인정보 수집 및 이용에 대한 사항을 규정합니다.
          <br />
          <br />
          <br />
          <br />
          제 2 조 (수집하는 개인정보 항목 및 수집 방법)
          <br />
          <br />
          1. 수집하는 개인정보 항목: 이메일,
          연락처, 닉네임, 게임 테스트 참여 기록 등
          <br />
          2. 개인정보 수집 방법: 서비스 가입 및 이용 과정에서 이용자
          가 직접 입력하는 방식으로 수
          집됩니다.
          <br />
          <br />
          <br />
          <br />
          제 3 조 서비스
          <br />
          <br />
          회사는 다음의 목적을 위해 개인정보를 수집 및 이용합니다.
          <br />
          <br />
          1. 서비스 제공 및 운영
          <br />
          2. 테스트 참여 관리 및 분석
          <br />
          3. 고객 지원 및 문의 응대
          <br />
          4. 서비스 개선 및 연구
          <br />
          <br />
          <br />
          <br />

          제 4 조 (개인정보 보유 및 이용 기간)
          <br />
          <br />
          1. 회사는 개인정보를 이용자
          가 서비스 이용 기간 동안 보관합니다.
          <br />
          2. 이용자가 탈퇴 요청을 할 경우,
          관련 법령에 따라 일정 기간 이후 데이터를 파기합니다.
          <br />
          3.
          관련 법령에 따라 일정 기간 동안 보관이 필요한 경우 해당 법률에 따릅니다.
          <br />
          <br />
          <br />
          <br />

          제 5
          조 (개인정보 제공 및 위탁)
          <br />
          <br />
          1. 회사는 원칙적으로 이용자의 개인정보를 제3자에
          게
          제공하지 않습니다.
          <br />
          2. 다만, 법령에 따라 제공 의무가 발
          생하는 경우 또는 이용자의 별도 동의가 있는 경우에
          한하여 제공할 수 있습니다.

          <br />
          <br />
          <br />
          <br />

          제 6
          조 (이용자의 권
          리 및 행사 방법)
          <br />
          <br />

          1. 회사는 개인정보를 이용자
          가 서비스 이용 기간 동안 보관합니다.
          <br />
          2. 이용자가 탈퇴 요청을 할 경우,
          관련 법령에 따라 일정 기간 이후 데이터를 파기합니다.
          <br />
          3.
          관련 법령에 따라 일정 기간 동안 보관이 필요한 경우 해당 법률에 따릅니다.
          <br />
          <br />
          <br />
          <br />

          제 7
          조 (개인정보 보호를 위한
          조
          치)
          <br />
          <br />
          1. 회사는 개인정보 보호를 위해 관련 법령을 준수하며, 안전한 보관 및 처리를 위해 필요한
          기술적·
          관리적 보호
          조
          치를 시행합니다.
          <br />
          2. 회사는 개인정보 보호 책임자를 지정하여 개인정보 보호 업무를 총괄합니다.
          <br/>
          <br/>
          <br/>
          [부칙] 본 약관은 2025년 [4월] [01일]부터 시행됩니다.
        </ContentBox>
      </ModalBox>
    </ModalBg>
  );
}
